<template>
    <div>
        <div class="login-logo-wrap">
            <img v-if="shopLogo" :src="shopLogo" :alt="appName" class="login-logo" />
            <img v-else src="/assets/img/header/header-logo.svg" alt="프리원" class="login-logo" />
        </div>

        <div>
            <v-form ref="loginForm" lazy-validation @submit.prevent="login()" class="form-style">
                <div class="mb-3">
                    <input type="text" class="input-form" v-model="form.email" placeholder="이메일을 입력해주세요" required />
                </div>
                <div class="mb-3">
                    <div class="password-wrap">
                        <input :type="passwordShow ? 'text' : 'password'" class="input-form" v-model="form.password" placeholder="* * * * * * * *" autocomplete="current-password" required />
                        <button type="button" class="password-toggle" :title="passwordShow ? '비밀번호 감추기' : '비밀번호 보기'" @click="passwordShow = !passwordShow" tabindex="-1">
                            <i :class="passwordShow ? 'las la-eye' : 'las la-eye-slash'"></i>
                        </button>
                    </div>
                    <p class="password-hint">(8자 이상, 대소문자·숫자·특수문자 포함)</p>
                </div>
                <div class="find-links">
                    <span>아이디 찾기</span>
                    <!-- 비밀번호 찾기 버튼 숨김
                    <span class="link-divider">|</span>
                    <router-link :to="{ name: 'ForgotPassword', query: shopSlug ? { redirect: `/${shopSlug}` } : {} }" class="a-style">비밀번호 찾기</router-link>
                    -->
                </div>
                <button type="submit" @click="login" class="common-btn login-btn" :style="loginAccentColor ? { background: loginAccentColor, boxShadow: 'none' } : {}">로그인</button>
                <div v-if="loginQrCodeUrl" class="qr-code-wrap">
                    <img :src="loginQrCodeUrl" :alt="appName + ' QR코드'" class="qr-code-img" />
                </div>
                <router-link :to="shopSlug ? { name: 'Registration', query: { redirect: '/' + shopSlug } } : { name: 'Registration' }" class="common-btn register-btn">회원가입</router-link>
            </v-form>
            <!-- <div class="line"></div> -->
            <div class="social-login-field" v-if="(themeType === 'type_5' || themeType === 'type_6') && (generalSettings.social_login.naver == 1 || generalSettings.social_login.kakao == 1)">
                <button class="common-btn naver-login-btn" @click="naverLogin" v-if="generalSettings.social_login.naver == 1">
                    <img src="/assets/img/login/naver_icon.svg" />
                    네이버로 시작하기
                </button>
                <button class="common-btn kakao-login-btn" @click="kakaoLogin" v-if="generalSettings.social_login.kakao == 1">
                    <img src="/assets/img/login/kakao_icon.svg" />
                    카카오로 시작하기
                </button>
            </div>
        </div>

        <div v-if="false">
            <v-row no-gutters class="justify-center">
                <v-col cols="12" lg="6" order="2" order-lg="1" class="pa-10" v-if="isLoginBanner">
                    <banner :loading="false" :banner="$store.getters['app/banners'].login_page" class="mt-5 mt-lg-0" />
                </v-col>
                <v-col cols="12" order="1" order-lg="2" lg="6">
                    <div class="px-lg-7 text-center">
                        <v-form ref="loginForm" lazy-validation @submit.prevent="login()">
                            <div v-if="authSettings?.customer_login_with == 'email' || (!showPhoneField && authSettings?.customer_login_with == 'email_phone')" class="mb-4 text-left">
                                <div class="mb-1 fs-13 fw-500">
                                    {{ $t('email') }}
                                </div>
                                <v-text-field v-model="form.email" :placeholder="$t('email_address')" type="text" :error-messages="emailErrors" hide-details="auto" required outlined></v-text-field>
                                <div v-if="authSettings?.customer_login_with == 'email_phone'" class="text-end font-italic fs-12 opacity-70">
                                    <span class="primary--text c-pointer" @click="showPhoneField = !showPhoneField">{{ $t('use_phone_instead') }}</span>
                                </div>
                            </div>
                            <div v-if="authSettings?.customer_login_with == 'phone' || (showPhoneField && authSettings?.customer_login_with == 'email_phone')" class="mb-4 text-left">
                                <div class="mb-1 fs-13 fw-500">
                                    {{ $t('phone_number') }}
                                </div>
                                <vue-tel-input v-model="form.phone" v-bind="mobileInputProps" :only-countries="availableCountries" @validate="phoneValidate">
                                    <template #arrow-icon><span class="vti__dropdown-arrow">&nbsp;▼</span></template>
                                </vue-tel-input>
                                <div v-if="$v.form.phone.$error" class="v-text-field__details mt-2 pl-3">
                                    <div class="v-messages theme--light error--text" role="alert">
                                        <div class="v-messages__wrapper">
                                            <div class="v-messages__message">{{ $t('this_field_is_required') }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="!$v.form.phone.$error && form.showInvalidPhone" class="v-text-field__details mt-2 pl-3">
                                    <div class="v-messages theme--light error--text" role="alert">
                                        <div class="v-messages__wrapper">
                                            <div class="v-messages__message">
                                                {{ $t('phone_number_must_be_valid') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="authSettings?.customer_login_with == 'email_phone'" class="text-end font-italic fs-12 opacity-70">
                                    <span class="primary--text c-pointer" @click="showPhoneField = !showPhoneField">{{ $t('use_phone_instead') }}</span>
                                </div>
                            </div>
                            <div>
                                <div class="mb-1 fs-13 fw-500 text-left">
                                    {{ $t('password') }}
                                </div>
                                <v-text-field
                                    v-model="form.password"
                                    placeholder="* * * * * * * *"
                                    :error-messages="passwordErrors"
                                    :type="passwordShow ? 'text' : 'password'"
                                    :append-icon="passwordShow ? 'las la-eye' : 'las la-eye-slash'"
                                    autocomplete="current-password"
                                    class="input-group--focused"
                                    hide-details="auto"
                                    required
                                    outlined
                                    @click:append="passwordShow = !passwordShow"
                                ></v-text-field>
                                <div class="text-end font-italic fs-12 opacity-70">
                                    <router-link :to="{ name: 'ForgotPassword' }" class="primary--text">{{ $t('forgot_password') }}?</router-link>
                                </div>
                            </div>
                            <v-btn x-large class="px-16 mb-4" elevation="0" type="submit" color="primary" :loading="loading" :disabled="loading" @click="login">{{ $t('login') }}</v-btn>
                        </v-form>
                        <div v-if="generalSettings.social_login.facebook == 1 || generalSettings.social_login.twitter == 1 || generalSettings.social_login.google == 1">
                            <div class="d-flex align-center mb-3">
                                <span class="me-2 fs-13 fw-500 opacity-60">{{ $t('or') }}, {{ $t('login_with') }}</span>
                                <v-divider></v-divider>
                            </div>
                            <SocialLogin class="mb-5" />
                        </div>

                        <!-- 네이버 로그인 -->
                        <div class="border-top py-2" v-if="generalSettings.social_login.naver == 1 || generalSettings.social_login.kakao == 1">
                            <div class="d-flex align-center justify-center mt-3 mb-3">
                                <img :src="static_asset('/assets/img/icons/naver_login.png')" height="50" @click="naverLogin" style="cursor: pointer" v-if="generalSettings.social_login.naver == 1" />
                                <img
                                    :src="static_asset('/assets/img/icons/kakao_login.png')"
                                    height="50"
                                    @click="kakaoLogin"
                                    style="margin-left: 5px; cursor: pointer"
                                    v-if="generalSettings.social_login.kakao == 1"
                                />
                            </div>
                        </div>
                        <div>
                            {{ $t('dont_have_an_account') }},
                            <router-link :to="{ name: 'Registration' }" class="primary--text text-decoration-underline">{{ $t('signup') }}</router-link>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import { required, requiredIf, email } from 'vuelidate/lib/validators';
import SocialLogin from '../auth/SocialLogin';
import { VueTelInput } from 'vue-tel-input';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
    mounted() {
        if (window.Kakao && typeof window.Kakao.isInitialized === 'function' && this.generalSettings.kakao_login && this.generalSettings.kakao_login.KAKAO_JS_API_KEY) {
            if (!window.Kakao.isInitialized()) {
                window.Kakao.init(this.generalSettings.kakao_login.KAKAO_JS_API_KEY);
            }
        } else {
            console.warn('Kakao JS API Key is missing. Kakao login will not work.');
        }
    },
    data: () => ({
        isLoginBanner: false,
        shopLogo: null,
        shopSlug: null,
        loginAccentColor: null,
        loginQrCodeUrl: null,
        mobileInputProps: {
            inputOptions: {
                type: 'tel',
                placeholder: 'phone number',
            },
            dropdownOptions: {
                showDialCodeInSelection: false,
                showFlags: true,
                showDialCodeInList: true,
            },
            autoDefaultCountry: false,
            validCharactersOnly: true,
            mode: 'international',
        },
        showPhoneField: false,
        form: {
            social: '',
            phone: '',
            email: '',
            password: '',
            invalidPhone: true,
            showInvalidPhone: false,
        },
        passwordShow: false,
        loading: false,
        themeType: 'type_1',
    }),
    components: {
        SocialLogin,
        VueTelInput,
    },
    validations: {
        form: {
            email: {
                requiredIf: requiredIf(function () {
                    return this.authSettings?.customer_login_with == 'email' || (this.authSettings?.customer_login_with == 'email_phone' && !this.showPhoneField);
                }),
                email,
            },
            phone: {
                requiredIf: requiredIf(function () {
                    return this.authSettings?.customer_login_with == 'phone' || (this.authSettings?.customer_login_with == 'email_phone' && this.showPhoneField);
                }),
            },
            password: {
                required,
            },
        },
    },
    computed: {
        ...mapGetters('app', ['appUrl', 'generalSettings', 'availableCountries', 'demoMode', 'banners', 'appLogo', 'appName']),
        ...mapGetters('cart', ['getTempUserId']),
        ...mapGetters('auth', ['authSettings']),
        emailErrors() {
            const errors = [];
            if (!this.$v.form.email.$dirty) return errors;
            !this.$v.form.email.requiredIf && errors.push('이메일을 입력해주세요.');
            !this.$v.form.email.email && errors.push('이메일형식이 잘못되었습니다.');
            return errors;
        },
        passwordErrors() {
            const errors = [];
            if (!this.$v.form.password.$dirty) return errors;
            !this.$v.form.password.required && errors.push('비밀번호를 입력해주세요.');
            return errors;
        },
    },
    methods: {
        ...mapActions('auth', {
            actionLogin: 'login',
        }),
        debugLog(location, ...args) {
            if (process.env.NODE_ENV !== 'production') {
               // console.log(`[${location}]`, ...args);
            }
        },
        ...mapActions('app', ['fetchProductQuerries']),
        ...mapActions('wishlist', ['fetchWislistProducts']),
        ...mapActions('cart', ['fetchCartProducts']),
        ...mapMutations('cart', ['removeTempUserId']),
        ...mapMutations('auth', ['updateChatWindow', 'showLoginDialog']),
        phoneValidate(phone) {
            this.form.invalidPhone = phone.valid ? false : true;
            if (phone.valid) this.form.showInvalidPhone = false;
        },
        async login() {
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            if ((this.authSettings?.customer_login_with == 'phone' || (this.authSettings?.customer_login_with == 'email_phone' && this.showPhoneField)) && this.form.invalidPhone) {
                this.form.showInvalidPhone = true;
                return;
            }
            if (this.getTempUserId) {
                this.form.temp_user_id = this.getTempUserId;
            }
            this.form.phone = this.form.phone.replace(/\s/g, '');
            this.loading = true;
            // console.log('🔑 MAKING LOGIN API CALL...');
            const res = await this.call_api('post', 'auth/login', this.form);
            // console.log('🔑 LOGIN API RESPONSE:', res.data);
            
            if (res.data.success) {
                // console.log('🔑 LOGIN RESPONSE SUCCESS:', {
                //     responseData: res.data,
                //     hasAccessToken: !!res.data.access_token,
                //     verified: res.data.verified,
                //     authSettings: this.authSettings?.customer_otp_with
                // });
                
                if (res.data.verified == true || this.authSettings?.customer_otp_with == 'disabled') {
                    if (this.getTempUserId) {
                        this.removeTempUserId();
                    }
                    
                    // console.log('🔑 CALLING actionLogin with data:', res.data);
                    this.actionLogin(res.data);
                    
                    // console.log('🔑 AFTER actionLogin - Token check:', {
                    //     storeToken: this.$store.getters['auth/accessToken'],
                    //     localToken: localStorage.getItem('shopAccessToken'),
                    //     isAuthenticated: this.$store.getters['auth/isAuthenticated']
                    // });
                    
                    this.showLoginDialog(false);
                    this.updateChatWindow(false);

                    // 로그인 직후 SPA 내부 이동(router.push)만 하면 TheShop.vue에 한 번만 마운트되는
                    // Header.vue(상단메뉴)가 다시 created()를 타지 않아 로그인 전(비로그인/이전 사용자)
                    // 상태로 가져온 메뉴(setting/header 응답)가 그대로 남아 메뉴가 안 보이는 문제가 있었음
                    // (로그아웃 때와 동일한 원인). 완전한 페이지 새로고침으로 처리해 헤더 메뉴를 포함한
                    // 모든 컴포넌트 상태를 로그인된 사용자 기준으로 다시 받아오게 한다.
                    const useAfterLogin = res.data.user?.is_use_after_login === 1;
                    const defaultHref = useAfterLogin
                        ? this.$router.resolve({ name: 'AfterLogin' }).href
                        : '/mypage/dashboard';
                    const redirectParam = this.$route.query.redirect;
                    let target = defaultHref;
                    if (redirectParam) {
                        const resolved = this.$router.resolve(redirectParam);
                        // shop 페이지(ShopDetails 등)로의 redirect는 기본 홈으로 대체
                        const shopRoutes = ['ShopDetails', 'ShopCoupons', 'ShopProducts', 'ProductDetails'];
                        target = shopRoutes.includes(resolved.route.name) ? defaultHref : redirectParam;
                    }
                    window.location.href = target;
                } else {
                    if (this.authSettings?.customer_login_with == 'email' || (this.authSettings?.customer_login_with == 'email_phone' && this.authSettings?.customer_otp_with == 'email')) {
                        this.$router
                            .push({
                                name: 'VerifyAccount',
                                params: { email: this.form.email },
                            })
                            .catch((e) => {
                                // Handle navigation cancellation gracefully
                                if (
                                    e.name !== 'NavigationDuplicated' &&
                                    e.name !== 'NavigationCancelled' &&
                                    !e.message?.includes('Navigation cancelled') &&
                                    !e.message?.includes('NavigationDuplicated')
                                ) {
                                    console.warn('Navigation error:', e);
                                }
                            });
                    } else {
                        this.$router
                            .push({
                                name: 'VerifyAccount',
                                params: { phone: this.form.phone },
                            })
                            .catch((e) => {
                                // Handle navigation cancellation gracefully
                                if (
                                    e.name !== 'NavigationDuplicated' &&
                                    e.name !== 'NavigationCancelled' &&
                                    !e.message?.includes('Navigation cancelled') &&
                                    !e.message?.includes('NavigationDuplicated')
                                ) {
                                    console.warn('Navigation error:', e);
                                }
                            });
                    }
                }

                this.snack({
                    message: res.data.message,
                });
            } else {
                // console.log('🔑 LOGIN FAILED:', res.data);
                let message = res.data.message;

                // Nginx/Laravel rate limit: Retry-After 헤더에서 남은 시간 파싱
                if (res.status === 429 && !message) {
                    const retryAfter = res.headers?.['retry-after'];
                    const secs = retryAfter ? parseInt(retryAfter) : 60;
                    const mins = Math.ceil(secs / 60);
                    message = mins >= 2
                        ? `너무 많은 요청입니다. ${mins}분 후 다시 시도해주세요.`
                        : `너무 많은 요청입니다. ${secs}초 후 다시 시도해주세요.`;
                }

                this.snack({
                    message: message || '로그인에 실패했습니다.',
                    color: res.data?.locked ? 'orange darken-2' : 'red',
                });
            }
            this.loading = false;
        },

        async naverLogin() {
            const NAVER_CLIENT_ID = this.generalSettings.naver_login.NAVER_CLIENT_ID;

            const NAVER_REDIRECT_URI = this.appUrl + '/api/v1/auth/naver_login_callback';

            const naverLoginUrl = 'https://nid.naver.com/oauth2.0/authorize?client_id=' + NAVER_CLIENT_ID + '&redirect_uri=' + NAVER_REDIRECT_URI + '&response_type=code';

            // 네이버 로그인 팝업 열기
            const popup = window.open(naverLoginUrl, 'naverLoginPopup', 'width=600,height=700');

            // 팝업창에서 메시지 수신
            window.addEventListener('message', (event) => {
                // 네이버 로그인 성공 시 Access Token 수신
                if (event.data.success === '1') {
                    const email = event.data.email;
                    const password = event.data.password;
                    // Access Token을 사용하여 사용자 정보 가져오기 등의 추가 작업 수행
                    this.directLogin('naver', email, password);
                    // 팝업 창 닫기
                    popup.close();
                } else {
                    if (event.data.code == 'none') {
                        popup.close();

                        this.snack({
                            message: event.data.message + ' 회원가입 페이지로 이동합니다.',
                            color: 'info',
                        });

                        setTimeout(() => {
                            //새로고침시 값이 사라지는 것을 방지하기 위해 쿠키로 담는다.
                            document.cookie =
                                'social-login=' +
                                JSON.stringify({
                                    social: event.data.social,
                                    name: event.data.name,
                                    email: event.data.email,
                                    password: event.data.password,
                                    mobile: event.data.mobile,
                                }) +
                                '; path=/;';

                            this.$router.push({
                                name: 'Registration',
                            });
                        }, 2000);
                    } else {
                        if (event.data.message) {
                            this.snack({
                                message: event.data.message,
                                color: 'red',
                            });
                            popup.close();
                        }
                    }
                }
            });
        },
        kakaoLogin() {
            if (window.Kakao && window.Kakao.Auth && typeof window.Kakao.Auth.login === 'function') {
                window.Kakao.Auth.login({
                    success: (authObj) => {
                        this.debugLog('LoginForm_kakaoLogin', '로그인 성공!', authObj);
                        // 사용자 정보 요청
                        this.fetchKakaoUserProfile();
                    },
                    fail: (err) => {
                        console.error('로그인 실패', err);
                    },
                });
            } else {
                this.snack({
                    message: 'Kakao 로그인 기능을 사용할 수 없습니다. 페이지를 새로고침하거나, 관리자에게 문의하세요.',
                    color: 'red',
                });
            }
        },
        fetchKakaoUserProfile() {
            window.Kakao.API.request({
                url: '/v2/user/me',
                success: (res) => {
                    this.call_api('post', 'log/store', {
                        type: 'kakao_login_res',
                        data: JSON.stringify(res),
                    }).catch(() => {}); // ignore logging errors
                    this.debugLog('LoginForm_fetchKakaoUserProfile', '사용자 정보', res);
                    this.kakaoLoginCallback(res);
                },
                fail: (err) => {
                    console.error('사용자 정보 요청 실패', err);
                },
            });
        },
        async kakaoLoginCallback(params) {
            if (!params.kakao_account || !params.kakao_account.email) {
                this.snack({
                    message: '카카오 계정에서 이메일 정보를 받아올 수 없습니다. 카카오 계정에 이메일이 등록되어 있고, 이메일 제공에 동의했는지 확인해주세요.',
                    color: 'red',
                });
                return;
            }

            const email = params.kakao_account.email;
            const password = String(params.id);
            const res = await this.call_api('post', 'auth/kakao_login_callback', params);

            if (res.data.success) {
                this.debugLog('LoginForm_kakaoLoginCallback', 'Kakao login callback successful:', res);
                // Handle successful response

                this.directLogin('kakao', email, password);
            } else {
                console.error('Kakao login callback failed:', res.data.message);
                this.snack({
                    message: res.data.message,
                    color: 'red',
                });
            }
        },
        directLogin(social, email, password) {
            this.form.social = social;
            this.form.email = email;
            this.form.password = password;

            this.login();
        },
    },
    async created() {
        this.isLoginBanner = this.banners.login_page.img ? true : false;

        try {
            // shop_id 파라미터 우선, 없으면 redirect URL에서 slug 추출 (예: /kumon → kumon)
            const redirect = this.$route.query.redirect || '';
            const slug = this.$route.query.shop_id || redirect.split('/').filter(Boolean)[0];

            // 시스템 예약 경로는 shop slug가 아니므로 기본 로그인 폼 표시
            const RESERVED_SLUGS = ['mypage', 'user', 'checkout', 'helpdesk', 'guide', 'filebox', 'event', '404', 'all-shops', 'register-shop', 'product'];
            if (!slug || RESERVED_SLUGS.includes(slug)) {
                this.$emit('config-loaded', { bgColor: null, bgImageUrl: null, themeType: 'type_1' });
                return;
            }

            // shop 로그인 디자인 설정 조회 (비인증 공개 API)
            const configRes = await this.call_api('get', `shop/${slug}/login-config`);
            if (configRes.status === 404 || configRes.data?.found === false) {
                this.$router.replace({ name: '404' });
                return;
            }
            if (configRes.status === 200) {
                const cfg = configRes.data;
                this.shopLogo = cfg.login_logo_url || cfg.logo || null;
                this.shopSlug = slug;
                this.loginAccentColor = cfg.login_accent_color || null;
                this.loginQrCodeUrl = cfg.login_qr_code_url || null;
                this.themeType = cfg.theme_type || 'type_1';
                this.$emit('config-loaded', {
                    bgColor:         cfg.login_bg_color     || null,
                    bgImageUrl:      cfg.login_bg_image_url || null,
                    bgVideoUrl:      cfg.login_bg_video_url || null,
                    themeType:       this.themeType,
                    metaTitle:       cfg.meta_title        || null,
                    metaDescription: cfg.meta_description  || null,
                });
                return;
            }

            this.$emit('config-loaded', { bgColor: null, bgImageUrl: null, themeType: 'type_1' });
        } catch (e) {
            this.$emit('config-loaded', { bgColor: null, bgImageUrl: null, themeType: 'type_1' });
        }
    },
};
</script>
<style scoped>
.a-style {
    font-size: 16px;
    text-decoration: underline;
    text-underline-offset: 3px;
    color: #0a2975;
}

.find-links {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-top: 16px;
    margin-bottom: 30px;
    font-size: 16px;
    color: #555;
}

.link-divider {
    color: #ccc;
}

.login-logo-wrap {
    text-align: center;
    margin-bottom: 32px;
}
.login-logo {
    max-height: 150px;
    max-width: 100%;
    object-fit: contain;
}

.form-style {
    width: 100%;
}

.password-wrap {
    position: relative;
}

.password-hint {
    margin-top: 6px;
    font-size: 12px;
    color: #999;
}

.password-toggle {
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    color: #999;
    font-size: 20px;
    padding: 0;
    line-height: 1;
    z-index: 1;

    &:hover {
        color: #555;
    }
}

.password-wrap .input-form {
    padding-right: 44px;
}

.input-form {
    border: 1px solid #e5e5e5;
    background: #f8f8f8;
    width: 100%;
    height: 50px;
    padding: 15px 16px;

    &::placeholder {
        color: #c8c8c8;
    }

    color: inherit; /*#1d2945;*/
}

.line {
    border-top: 1px solid #e5e5e5;
    margin: 50px 0;
}

.common-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 90px;
    font-weight: 500;
    font-size: 24px;
    border-radius: 4px;
    cursor: pointer;

    img {
        margin-right: 20px;
    }
}

.login-btn {
    background: #ed672d;
    color: #fff;
    margin-bottom: 20px;
    height: 60px;
}

.register-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    color: #ed672d;
    border: 2px solid #ed672d;
    margin-top: 20px;
    text-decoration: none;
    height: 60px;
}

.naver-login-btn {
    background: #03c75a;
    color: #fff;

    font-size: 24px;
}
.kakao-login-btn {
    background: #fae743;
    color: #181602;

    font-size: 24px;
}

.qr-code-wrap {
    text-align: center;
    margin-bottom: 30px;
}
.qr-code-img {
    max-width: 80px;
    max-height: 80px;
    object-fit: contain;
}

.social-login-field {
    width: 100%;

    button {
        &:nth-of-type(2) {
            margin-top: 20px;
        }
    }
}
</style>
